
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ValueAndLabelConverter} from '../../../../../common/converter/ValueAndLabel.converter';
import {AccountingMovementSummaryModel} from '../accountingMovementSummary.model';
import {PermissionsConverter} from '../../../../../common/converter/permissions.converter';
import {DateConverter} from '../../../../../common/converter/date.converter';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {BankCheckSummaryConverter} from "../../../../bank-check/api/model/converter/bankCheckSummary.converter";
@Injectable({providedIn: 'root'})
export class AccountingMovementSummaryConverter extends HttpModelConverter<AccountingMovementSummaryModel> {


    constructor(private valueAndLabelConverter: ValueAndLabelConverter,
                private dateConverter: DateConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private bankCheckConverter: BankCheckSummaryConverter,
                private permissionsConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): AccountingMovementSummaryModel {
        return new AccountingMovementSummaryModel();
    }

    protected enrichObject(result: AccountingMovementSummaryModel, src: AccountingMovementSummaryModel) {
        result.paymentType = this.valueAndLabelConverter.convert(src.paymentType);
        result.type = this.valueAndLabelConverter.convert(src.type);
        result.permissions = this.permissionsConverter.convert(src.permissions);
        result.date = this.dateConverter.convert(src.date);
        result.counterparty = this.lovValueSummaryConverter.convert(src.counterparty);
        result.bankCheck = this.bankCheckConverter.convert(src.bankCheck);
    }


}
